import { createElement as h } from "react";
import ReactMarkdown, { defaultUrlTransform } from "react-markdown";

// Share captioned photo rendering between the live article and its static page.
export default function BlogArticleMarkdown({ body, media = {} }) {
  return h(ReactMarkdown, {
    children: body,
    components: {
      p({ node, children }) {
        const images = node.children.filter((child) => child.tagName === "img");
        const isPhotoParagraph = images.length > 0 && node.children.every(
          (child) => child.tagName === "img" || (child.type === "text" && !child.value.trim())
        );
        if (!isPhotoParagraph) return h("p", null, children);

        return h("div", { className: images.length > 1 ? "blog-media-grid" : "blog-media" },
          images.map(({ properties }) => {
            const { src, alt, title } = properties;
            const asset = media[src] || {};
            const image = h("img", {
              src: defaultUrlTransform(src), alt: alt || "", loading: "lazy", decoding: "async",
              width: asset.width, height: asset.height,
              style: { display: "block", width: "100%", height: "auto" },
            });
            return h("figure", {
              key: src,
              className: asset.kind === "screen" ? "blog-photo blog-photo-screen" : "blog-photo",
              style: { margin: "24px auto", maxWidth: asset.kind === "screen" ? "600px" : "100%" },
            },
            asset.kind === "screen" ? h("a", {
              href: defaultUrlTransform(src),
              "aria-label": "Open tablet scorecard at full size", title: "Open full-size screenshot",
            }, image) : image,
            title ? h("figcaption", null, title) : null);
          })
        );
      },
    },
  });
}
